import { Component, afterNextRender, inject, output, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { RegistrationFormsService } from '../forms/registration-forms.service';
import { PasswordErrors } from '../forms/validators';
import { PasswordTips } from '../ui/password-tips/password-tips';
import { VcInput } from '../ui/vc-input/vc-input';

@Component({
  selector: 'app-step1',
  imports: [ReactiveFormsModule, TranslatePipe, VcInput, PasswordTips],
  templateUrl: './step1.html',
  styleUrl: './step1.scss',
})
export class Step1 {
  readonly next = output();

  protected readonly form = inject(RegistrationFormsService).step1;
  protected readonly passwordFocused = signal(false);
  // the sandbox APP_URL ends with a slash
  protected readonly signInUrl = `${environment.APP_URL.replace(/\/$/, '')}/login`;

  constructor() {
    afterNextRender(() => setTimeout(() => document.querySelector<HTMLInputElement>('[name="firstName"]')?.focus(), 300));
  }

  protected passwordErrors(): PasswordErrors | null {
    return this.form.controls.password.errors;
  }

  protected passwordTipsOpen() {
    const password = this.form.controls.password;
    return this.passwordFocused() || (password.invalid && password.touched);
  }

  protected goToStep2() {
    this.next.emit();
  }
}
